<template>
  <dialog-component
    :dialogData="dialogData"
    :isShow="isShow"
    width="820"
    @next="handlerNext"
    @cancel="isShow = false">
    <div class="dialog-content">
      <el-form
        ref="form"
        :model="formData"
        :rules="rules">
        <div class="half">
          <div class="form-half">
            <div class="form-item">
              <span>Name (English)</span>
              <el-form-item
                :rules="rules.input"
                prop="name_en_us">
                <v-input v-model="formData.name_en_us" />
              </el-form-item>
            </div>
            <div class="form-item">
              <span>Name (Traditional Chinese)</span>
              <el-form-item
                :rules="rules.input"
                prop="name_zh_hk">
                <v-input v-model="formData.name_zh_hk" />
              </el-form-item>
            </div>
          </div>
          <div class="form-half">
            <v-checkbox
              v-model="formData.show_in"
              :isBoolean="false">Show in AlipayHK</v-checkbox>
          </div>
        </div>
        <div class="form-main">
          <div class="half">
            <div class="form-half">
              <div class="form-item">
                <v-checkbox
                  v-model="formData.ads[0].is_show_ad"
                  :isBoolean="false"
                  :otherData="{
                    index: 0
                  }"
                  @change="handlerChangeEnableAd">Enable Ad1</v-checkbox>
              </div>
            </div>
            <div class="form-half">
              <div class="form-item">
                <v-checkbox
                  v-model="formData.ads[1].is_show_ad"
                  :isBoolean="false"
                  :otherData="{
                    index: 1
                  }"
                  @change="handlerChangeEnableAd">Enable Ad2</v-checkbox>
              </div>
            </div>
          </div>

          <section>
            <div class="half">
              <div class="half-item">
                <div v-show="formData.ads[0].is_show_ad == 1">
                  <div class="form-item">
                    <span>
                      Period
                      <span class="tag">Optional</span>
                    </span>
                    <el-form-item
                      :rules="formData.ads[0].is_show_ad == 1? rules.period: []"
                      prop="ads.0.date">
                      <v-datetime-picker
                        v-model="formData.ads[0].date"
                        format="dd-MM-yyyy HH:mm:ss"
                        placeholder="dd-MM-yyyy HH:mm:ss"
                        valueFormat="yyyy-MM-dd HH:mm:ss"
                        :defaultTime="['00:00:00','23:59:59']"
                        type="datetimerange"></v-datetime-picker>
                    </el-form-item>
                  </div>
                  <div class="form-item">
                    <span>Ad 1 Image (English)</span>
                    <el-form-item
                      :rules="formData.ads[0].is_show_ad == 1? rules.upload: []"
                      prop="ads.0.data.en.url">
                      <v-upload
                        :card="true"
                        :notUpload="true"
                        widthFull
                        :otherData="{
                          lang: 'en',
                          index: 0
                        }"
                        :fileData="{
                          url: formData.ads[0].data['en'].url,
                          thumb_url: formData.ads[0].data['en'].url
                        }"
                        @uploadForm="handlerUploadSuccess"
                        @delete="handlerUploadDelete" />
                    </el-form-item>
                  </div>
                  <div class="form-item">
                    <span>
                      Ad 1 Link (English)
                      <span class="tag">Optional</span>
                    </span>
                    <el-form-item
                      :rules="rules.ad_link"
                      prop="ads.0.data.en.link">
                      <v-input v-model="formData.ads[0].data.en.link" />
                    </el-form-item>
                  </div>
                  <div class="form-item">
                    <span>Ad 1 Image (Traditional Chinese)</span>
                    <el-form-item
                      :rules="formData.ads[0].is_show_ad == 1? rules.upload: []"
                      prop="ads.0.data.hk.url">
                      <v-upload
                        :card="true"
                        :notUpload="true"
                        widthFull
                        :otherData="{
                          lang: 'hk',
                          index: 0
                        }"
                        :fileData="{
                          url: formData.ads[0].data['hk'].url,
                          thumb_url: formData.ads[0].data['hk'].url
                        }"
                        @uploadForm="handlerUploadSuccess"
                        @delete="handlerUploadDelete" />
                    </el-form-item>
                  </div>
                  <div class="form-item">
                    <span>
                      Ad 1 Link (Traditional Chinese)
                      <span class="tag">Optional</span>
                    </span>
                    <el-form-item
                      :rules="rules.ad_link"
                      prop="ads.0.data.hk.link">
                      <v-input v-model="formData.ads[0].data.hk.link" />
                    </el-form-item>
                  </div>
                </div>
              </div>
              <div class="half-item">
                <div v-show="formData.ads[1].is_show_ad == 1">
                  <div class="form-item">
                    <span>
                      Period
                      <span class="tag">Optional</span>
                    </span>
                    <el-form-item
                      :rules="formData.ads[1].is_show_ad == 1? rules.period: []"
                      prop="ads.1.date">
                      <v-datetime-picker
                        v-model="formData.ads[1].date"
                        format="dd-MM-yyyy HH:mm:ss"
                        placeholder="dd-MM-yyyy HH:mm:ss"
                        valueFormat="yyyy-MM-dd HH:mm:ss"
                        :defaultTime="['00:00:00','23:59:59']"
                        type="datetimerange"></v-datetime-picker>
                    </el-form-item>
                  </div>
                  <div class="form-item">
                    <span>Ad 2 Image (English)</span>
                    <el-form-item
                      :rules="formData.ads[1].is_show_ad == 1? rules.upload: []"
                      prop="ads.1.data.en.url">
                      <v-upload
                        :card="true"
                        :notUpload="true"
                        widthFull
                        :otherData="{
                          lang: 'en',
                          index: 1
                        }"
                        :fileData="{
                          url: formData.ads[1].data['en'].url,
                          thumb_url: formData.ads[1].data['en'].url
                        }"
                        @uploadForm="handlerUploadSuccess"
                        @delete="handlerUploadDelete" />
                    </el-form-item>
                  </div>
                  <div class="form-item">
                    <span>
                      Ad 2 Link (English)
                      <span class="tag">Optional</span>
                    </span>
                    <el-form-item
                      :rules="rules.ad_link"
                      prop="ads.1.data.en.link">
                      <v-input v-model="formData.ads[1].data.en.link" />
                    </el-form-item>
                  </div>
                  <div class="form-item">
                    <span>Ad 2 Image (Traditional Chinese)</span>
                    <el-form-item
                      :rules="formData.ads[1].is_show_ad == 1? rules.upload: []"
                      prop="ads.1.data.hk.url">
                      <v-upload
                        :card="true"
                        :notUpload="true"
                        widthFull
                        :otherData="{
                          lang: 'hk',
                          index: 1
                        }"
                        :fileData="{
                          url: formData.ads[1].data['hk'].url,
                          thumb_url: formData.ads[1].data['hk'].url
                        }"
                        @uploadForm="handlerUploadSuccess"
                        @delete="handlerUploadDelete" />
                    </el-form-item>
                  </div>
                  <div class="form-item">
                    <span>
                      Ad 2 Link (Traditional Chinese)
                      <span class="tag">Optional</span>
                    </span>
                    <el-form-item
                      :rules="rules.ad_link"
                      prop="ads.1.data.hk.link">
                      <v-input v-model="formData.ads[1].data.hk.link" />
                    </el-form-item>
                  </div>
                </div>
              </div>
            </div>
          </section>

        </div>
      </el-form>
    </div>
  </dialog-component>
</template>
<script>
import { 
  addNewsCategory, 
  updateNewsCategory,
  uploadNewsImage } from '@/api/news'
import MixinRules from '@/mixins/rules'
  
export default {
  name: 'CategoryPopup',
  mixins: [MixinRules],
  props: {
    value: {
      type: Boolean,
      default: false
    },
    form: {
      type: Object,
      default: () => ({})
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    id: {
      type: Number,
      default: -1
    }
  },
  data() {
    return {
      isShow: false,
      formData: {
        name_en_us: '',
        name_zh_hk: '',
        show_in: 1,
        ads: [
          {
            data:{
              hk: {
                link: '',
                image: '',
                url: ''
              },
              en: {
                link: '',
                image: '',
                url: ''
              }
            },
            is_show_ad: 0,
            date: [],
            period: {
              start: '',
              end: '',
            }
          },
          {
            data:{
              hk: {
                link: '',
                image: '',
                url: ''
              },
              en: {
                link: '',
                image: '',
                url: ''
              }
            },
            is_show_ad: 0,
            date: [],
            period: {
              start: '',
              end: '',
            }
          },
        ]
      },
    }
  },
  computed: {
    dialogData() {
      return {
        title: `${this.isEdit? 'Edit': 'Create'} Category`,
        buttonRightText: 'Confirm',
      }
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(status) {
        if(status !== this.isShow) {
          this.isShow = status
        }
      }
    },
    isShow: {
      handler(status) {
        if(status !== this.value) {
          this.$emit('input', status)
        }
        if(!status) {
          this.formData = {
            name_en_us: '',
            name_zh_hk: '',
            show_in: 0,
            ads: [
              {
                data:{
                  hk: {
                    link: '',
                    image: '',
                    url: ''
                  },
                  en: {
                    link: '',
                    image: '',
                    url: ''
                  }
                },
                is_show_ad: 0,
                date: [],
                period: {
                  start: '',
                  end: '',
                }
              },
              {
                data:{
                  hk: {
                    link: '',
                    image: '',
                    url: ''
                  },
                  en: {
                    link: '',
                    image: '',
                    url: ''
                  }
                },
                is_show_ad: 0,
                date: [],
                period: {
                  start: '',
                  end: '',
                }
              },
            ]
          }
        }
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler(data) {
        this.$nextTick(()=>{
          if(data) {
            // 預填數據
            const { name_language, ads=[], show_in, id } = data||{}
            this.$set(this.formData, 'name_en_us', name_language['en-US'])
            this.$set(this.formData, 'name_zh_hk', name_language['zh-HK'])
            this.$set(this.formData, 'show_in', show_in)
            if(ads && ads.length > 0) {
              ads.forEach((item, i) => {
                if(item.is_show_ad){
                  const hk = {
                    link: item.data['zh-HK'].link,
                    image: item.data['zh-HK'].image,
                    url: item.data['zh-HK'].image_url
                  }
                  const en = {
                    link: item.data['en-US'].link,
                    image: item.data['en-US'].image,
                    url: item.data['en-US'].image_url
                  }
                  let res = {
                    data: {
                      hk,
                      en
                    },
                    is_show_ad: item.is_show_ad,
                    date: [],
                    period: item.period || {
                      start: '',
                      end: '',
                    }
                  }
                  this.$set(this.formData.ads, i, res)
                }
              })
            }
          }
        })
      }
    },
    formData:{
      immediate: true,
      deep: true,
      handler(val){
        val.ads.forEach(item => {
          let period = item.period
          if(item.date == null){
            item.period.start = ''
            item.period.end = ''
          }
          if(item.date && item.date.length > 0){
            item.period.start = item.date[0]
            item.period.end = item.date[1]
          }
          if(period && period.start && period.end && (item.date && item.date.length == 0)){
            item.date = []
            item.date.push(period.start)
            item.date.push(period.end)
          }
        })
      }
    },
  },
  methods: {
    handlerChangeEnableAd(status, other) {
      if(!status) {
        const {index} = other
        this.$refs['form'].clearValidate([
          `ads.${index}.data.en.url`,
          `ads.${index}.data.hk.url`,
        ])
      }
    },
    handlerNext() {
      this.$refs['form'].validate((valid, rules) => {
        if(valid) {
          if(this.isEdit) {
            this.network().updateNewsCategory()
          }
          else {
            this.network().addNewsCategory()
          }
        }
        else {
          console.log(rules)
        }
      })
      
    },
    handlerUploadSuccess({ params, result, otherData }) {
      this.network().uploadNewsImage({
        params,
        result,
        otherData
      })
    },
    handlerUploadDelete({ otherData }) {
      const { lang, index } = otherData
      this.$set(
        this.formData.ads[index].data[lang],
        'image',
        ''
      )
      this.$set(
        this.formData.ads[index].data[lang],
        'url',
        ''
      )
      this.$refs['form'].clearValidate([`ads.${index}.data.${lang}.url`])
    },
    resetForm(){
      if(this.$refs['form']){
        this.$refs['form'].resetFields()
      }
    },
    network() {
      return {
        uploadNewsImage: async ({ params, result, otherData }) => {
          const { data } = await uploadNewsImage(params)
          const { lang, index } = otherData
          const { url } = result
          this.$set(
            this.formData.ads[index].data[lang],
            'image',
            data.image_id
          )
          this.$set(
            this.formData.ads[index].data[lang],
            'url',
            url
          )

          this.$refs['form'].clearValidate([`ads.${index}.data.${lang}.url`])
        },
        addNewsCategory: async () => {
          const { data } = await addNewsCategory(this.formData)
          this.$emit('update')
          this.isShow = false
        },
        updateNewsCategory: async () => {
          const { data } = await updateNewsCategory({
            ...this.formData,
            category_id: this.id
          })
          this.$emit('update')
          this.isShow = false
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-container {
  .half{
    display: flex;
    justify-content: space-between;
    width: 100%;
    .form-half {
      .el-checkbox{
        color: #24292E;
        font-weight: 600;
      }
      .el-input{
        width: 330px;
      }
      & + .form-half{
        margin-left: 30px;
      }
    }
  }
  .form-main {
    margin-top: 10px;
    padding-top: 30px;
    border-top: 1px solid rgba(0, 0, 0, .2);
    // .form-item-half {
    //   display: flex;
    //   justify-content: space-between;
    //   width: 100%;
    //   .form-item {
    //     // flex: 1;
    //     width: calc(50% - 15px);
    //   }
    // }
    .half{
      display: flex;
      justify-content: space-between;
      .half-item{
        width: calc(50% - 15px);
      }
    }
    .tag{
      padding: 0px 8px;
      background: #E1E4E8;
      border-radius: 100px;
      width: 66px;
      height: 18px;
      color: #586069;
      font-weight: 600;
      font-size: 12px;
      margin-left: 10px;
    }
    .i-datetime-picker{
      /deep/.date-picker{
        width: 100%;
      }
    }
  }
}
</style>